import React, { useState } from 'react';
import { ArrowDown, SortDown } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { noop } from '@fabric-ui/utils';
import { Avatar, Box, Button, Menu, MenuItem } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useAvContext } from '../context';

const arrowIcon = <ArrowDown style={{ transform: `rotate(90deg)` }} />;
const popoverStyle = theme => ({
  pointerEvents: 'none',
  '.MuiMenu-paper': {
    pointerEvents: 'auto',
    minWidth: 250,
  },
  '.MuiMenuItem-root': {
    paddingLeft: '8px',
    minHeight: 40,
    color: theme.palette.colors.neutrals[800],
  },
});
interface SwitchAccountMenuProps {
  closeParent: any;
  setFilteredAppsBarItems: (arg0: any[]) => void;
}
export const SwitchAccountMenu: React.FC<SwitchAccountMenuProps> = ({ closeParent = noop, setFilteredAppsBarItems }) => {
  const { setAccountId, setSelectedApp, user } = useAvContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [sortAsc, setSortAsc] = useState(true);
  const handleClick = ({ currentTarget }) => {
    setAnchorEl(currentTarget);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const switchAcc = id => {
    setAccountId(id);
    handleClose();
    closeParent();
    setFilteredAppsBarItems([]);
    setSelectedApp('');
  };

  const accounts = user.accounts?.sort((a, b) =>
    sortAsc ? a.accountName.localeCompare(b.accountName) : b.accountName.localeCompare(a.accountName)
  );

  if (!accounts || accounts.length === 1) {
    return null;
  }

  return (
    <MenuItem onClick={e => e.stopPropagation()} onMouseEnter={handleClick} onMouseLeave={handleClose}>
      <>
        {arrowIcon}
        <Box
          aria-label="switch account"
          aria-controls={open ? 'accounts-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true">
          Switch account
        </Box>
      </>

      <Menu
        id="accounts-menu"
        MenuListProps={{ 'aria-labelledby': 'long-button' }}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'center', horizontal: 'right' }}
        open={open}
        sx={popoverStyle}
        PaperProps={{ onMouseEnter: () => setOpen(true), onMouseLeave: handleClose }}>
        {accounts.length > 4 ? (
          <Box sx={{ ...flex.justifyEnd, px: 1 }}>
            <Button onClick={() => setSortAsc(!sortAsc)} sx={{ gap: 0 }}>
              <SortDown style={{ height: 18, width: 18, ...(sortAsc && { transform: 'rotate(180deg)' }) }} />
              A-Z
            </Button>
          </Box>
        ) : null}
        {accounts.map(({ accountId: id, accountName: name }) => (
          <Box component={Link as any} key={id} to="/$accountId" params={{ accountId: id }} sx={{ textDecoration: 'none' }} ignoreBlocker>
            <MenuItem selected={id === user.accountId} onClick={id === user.accountId ? undefined : () => switchAcc(id)}>
              <Avatar src={`/account-logo/${id}.png`} alt={name} sx={{ width: 30, height: 30 }} />
              {name}
            </MenuItem>
          </Box>
        ))}
      </Menu>
    </MenuItem>
  );
};
